// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bwtoj{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-bdyws{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bzdlj{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bddhj{grid-column:span 3}.assets-scss-gridstyleGrid-col4-pckyb{grid-column:span 4}.assets-scss-gridstyleGrid-col9-vogji{grid-column:span 9}.assets-scss-gridstyleGrid-col12-jnxha{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bomxm{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bwtoj",
	"grid": "assets-scss-gridstyleGrid-grid-bdyws",
	"col6": "assets-scss-gridstyleGrid-col6-bzdlj",
	"col3": "assets-scss-gridstyleGrid-col3-bddhj",
	"col4": "assets-scss-gridstyleGrid-col4-pckyb",
	"col9": "assets-scss-gridstyleGrid-col9-vogji",
	"col12": "assets-scss-gridstyleGrid-col12-jnxha",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bomxm"
};
module.exports = ___CSS_LOADER_EXPORT___;
